/* Меню Табс*/
import React from 'react';
import './style.css';

class MenuTabs extends React.Component {

	getMenu = (children, funChange) => {
		let { activeItem } = this.props
		return (
			children.map((item, i) => {
				let { title, id } = item.props

				return (
					<div 
						onClick={() => {
							funChange(id)
						}} 
						className={`titleContainer ${(activeItem === id) ? "active" : ""}`} 
						key={i}
					>
						{title}
					</div>
				)

			})
		)
	}

	getContent = (children) => {
		let { activeItem } = this.props
		return children.find(({props}) => {
			return (props.id === activeItem) ? true : false
		})
	}

	render() {
		let { children, changeMenu } = this.props
		return (
			<div>
				<div className="mainMenuContainer horizontal-scroll-wrapper">
					{ this.getMenu(children, changeMenu) }
				</div>
				<div className="mainContentContainer">
					{ this.getContent(children) }
				</div>
			</div>
		)
	}
}

export default MenuTabs;